module.exports = __webpack_public_path__ + "media/39.756a3443.wav";